(function () {
  if (window.RealleaderQuoteRequest) return;

  var selector = 'form[data-rl-quote-request-form]';
  var pendingReferencePrefix = 'realleader_quote_reference:';
  var successGuardPrefix = 'realleader_quote_submitted:';
  var snapshotReadyAttribute = 'data-rl-quote-snapshot-ready';
  var preflightTokenAttribute = 'data-rl-quote-preflight-token';
  var nativeHandoffAttribute = 'data-rl-quote-native-handoff';
  var preflightDeadlineMs = 12000;
  var preflightSequence = 0;
  var successPublishedThisPage = false;
  var activeRequestState = null;

  function timeoutError(message) {
    var error = new Error(message);
    error.name = 'TimeoutError';
    error.code = 'RL_FETCH_TIMEOUT';
    return error;
  }

  function fetchWithDeadline(url, options, deadlineMs, timeoutMessage, handleResponse) {
    var controller = typeof window.AbortController === 'function' ? new window.AbortController() : null;
    var requestOptions = {};

    Object.keys(options || {}).forEach(function (key) {
      requestOptions[key] = options[key];
    });
    if (controller) requestOptions.signal = controller.signal;

    return new Promise(function (resolve, reject) {
      var settled = false;
      var timer = window.setTimeout(function () {
        if (settled) return;
        settled = true;
        if (controller) {
          try {
            controller.abort();
          } catch (error) {
            // Reject with the stable timeout error below even if abort is unavailable here.
          }
        }
        reject(timeoutError(timeoutMessage));
      }, deadlineMs);

      function settle(callback, value) {
        if (settled) return;
        settled = true;
        window.clearTimeout(timer);
        callback(value);
      }

      try {
        fetch(url, requestOptions).then(function (response) {
          return typeof handleResponse === 'function' ? handleResponse(response) : response;
        }).then(function (value) {
          settle(resolve, value);
        }, function (error) {
          settle(reject, error);
        });
      } catch (error) {
        settle(reject, error);
      }
    });
  }

  function withFinally(promise, callback) {
    if (typeof promise.finally === 'function') return promise.finally(callback);
    return promise.then(function (value) {
      callback();
      return value;
    }, function (error) {
      callback();
      throw error;
    });
  }

  function referenceStorageKey(form) {
    return pendingReferencePrefix + (form.getAttribute('id') || window.location.pathname || 'quote');
  }

  function storageGet(key) {
    try {
      return window.sessionStorage.getItem(key) || '';
    } catch (error) {
      return '';
    }
  }

  function storageSet(key, value) {
    try {
      window.sessionStorage.setItem(key, value);
      return true;
    } catch (error) {
      return false;
    }
  }

  function referenceToken() {
    try {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID().replace(/-/g, '').slice(0, 16).toUpperCase();
      }
      if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
        var values = new Uint32Array(2);
        window.crypto.getRandomValues(values);
        return Array.prototype.map.call(values, function (value) {
          return value.toString(16).padStart(8, '0');
        }).join('').toUpperCase();
      }
    } catch (error) {
      // Use the timestamp/random fallback below in restricted browser contexts.
    }
    return (Date.now().toString(36) + Math.random().toString(36).slice(2, 12)).toUpperCase();
  }

  function createReference() {
    var date = new Date();
    var datePart = [
      date.getUTCFullYear(),
      String(date.getUTCMonth() + 1).padStart(2, '0'),
      String(date.getUTCDate()).padStart(2, '0')
    ].join('');
    return 'RL-' + datePart + '-' + referenceToken();
  }

  function updateReturnTo(form, reference) {
    var field = form.querySelector('[name="return_to"]');
    if (!field || !reference) return;
    try {
      var target = new URL(field.value || window.location.pathname, window.location.origin);
      target.searchParams.set('quote_reference', reference);
      field.value = target.pathname + target.search + target.hash;
    } catch (error) {
      // The original Shopify return_to value remains a valid fallback.
    }
  }

  function ensureReference(form) {
    var field = form.querySelector('[data-rl-quote-reference]');
    if (!field) return '';
    var key = referenceStorageKey(form);
    var reference = storageGet(key) || createReference();
    field.value = reference;
    storageSet(key, reference);
    updateReturnTo(form, reference);
    return reference;
  }

  function clearPendingReferences() {
    try {
      for (var index = window.sessionStorage.length - 1; index >= 0; index -= 1) {
        var key = window.sessionStorage.key(index);
        if (key && key.indexOf(pendingReferencePrefix) === 0) {
          window.sessionStorage.removeItem(key);
        }
      }
    } catch (error) {
      // Storage is optional; quote delivery does not depend on it.
    }
  }

  function cartJsonUrl(form) {
    var base = form.getAttribute('data-rl-cart-json-url') || '/cart';
    return /\.js(?:$|\?)/.test(base) ? base : base.replace(/(\?.*)?$/, '.js$1');
  }

  function currencyFor(cart, form) {
    var field = form.querySelector('[data-rl-quote-currency]');
    return (cart && cart.currency) || (field && field.value) || 'GBP';
  }

  function formatMoney(cents, currency) {
    var amount = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency',
        currency: currency
      }).format(amount);
    } catch (error) {
      return amount.toFixed(2) + ' ' + currency;
    }
  }

  function priceBasis(cents) {
    return Number(cents) > 0 ? ' EX-VAT' : '';
  }

  function safeText(value) {
    if (value === null || typeof value === 'undefined') return '';
    if (typeof value === 'object') {
      try {
        return JSON.stringify(value);
      } catch (error) {
        return String(value);
      }
    }
    return String(value);
  }

  function absoluteUrl(path) {
    try {
      return new URL(path || '', window.location.origin).href;
    } catch (error) {
      return path || '';
    }
  }

  function formatBasket(cart, form) {
    var currency = currencyFor(cart, form);
    var reference = form.querySelector('[name="contact[quote_reference]"]');
    var lines = [
      'REALLEADER UK QUOTE BASKET',
      'Schema version: 1.0',
      'Reference: ' + (reference ? reference.value : ''),
      'Refreshed: ' + new Date().toISOString(),
      'Source page: ' + window.location.href,
      'Locale: ' + (document.documentElement.lang || 'en-GB'),
      'Currency: ' + currency,
      'Total quantity: ' + (cart.item_count || 0),
      ''
    ];

    (cart.items || []).forEach(function (item, index) {
      lines.push((index + 1) + '. ' + safeText(item.product_title || item.title));
      if (item.key) lines.push('Line key: ' + item.key);
      if (item.product_id) lines.push('Product ID: ' + item.product_id);
      if (item.variant_id) lines.push('Variant ID: ' + item.variant_id);
      if (item.handle) lines.push('Product handle: ' + item.handle);
      if (item.variant_title && item.variant_title !== 'Default Title') {
        lines.push('Variant: ' + item.variant_title);
      }
      if (item.sku) lines.push('SKU: ' + item.sku);
      lines.push('Quantity: ' + (item.quantity || 0));
      lines.push('Unit price: ' + formatMoney(item.final_price, currency) + priceBasis(item.final_price));
      lines.push('Line total: ' + formatMoney(item.final_line_price, currency) + priceBasis(item.final_line_price));
      lines.push('Product: ' + absoluteUrl(item.url));

      Object.keys(item.properties || {}).forEach(function (key) {
        var value = item.properties[key];
        if (!key || key.charAt(0) === '_' || value === null || value === '') return;
        lines.push(key + ': ' + safeText(value));
      });

      if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
        lines.push('Plan: ' + safeText(item.selling_plan_allocation.selling_plan.name));
      }
      lines.push('');
    });

    lines.push('Indicative quote subtotal: ' + formatMoney(cart.total_price, currency) + priceBasis(cart.total_price));
    if (cart.note) lines.push('Basket note: ' + safeText(cart.note));
    lines.push('Privacy notice version: theme-quote-notice-2026-08-09');
    lines.push('This is a quote request only. It is not an order and no payment has been taken.');
    return lines.join('\n');
  }

  function updateSnapshot(form, cart) {
    var payload = form.querySelector('[data-rl-quote-basket-payload]');
    var count = form.querySelector('[data-rl-quote-item-count]');
    var subtotal = form.querySelector('[data-rl-quote-subtotal]');
    var currency = currencyFor(cart, form);

    if (payload) payload.value = formatBasket(cart, form);
    if (count) count.value = String(cart.item_count || 0);
    if (subtotal) subtotal.value = formatMoney(cart.total_price, currency) + priceBasis(cart.total_price);
  }

  function setStatus(form, message, isError) {
    var status = form.querySelector('[data-rl-quote-request-status]');
    if (!status) return;
    status.textContent = message || '';
    status.setAttribute('role', isError ? 'alert' : 'status');
    if (isError) {
      status.setAttribute('tabindex', '-1');
      status.focus();
    } else {
      status.removeAttribute('tabindex');
    }
  }

  function setBusy(form, busy, busyLabel) {
    var button = form.querySelector('[data-rl-quote-request-submit]');
    var label = form.querySelector('[data-rl-quote-request-submit-label]');
    form.classList.toggle('is-loading', busy);
    if (busy) form.setAttribute('aria-busy', 'true');
    else form.removeAttribute('aria-busy');
    if (button) button.disabled = busy;
    if (label) label.textContent = busy ? (busyLabel || 'Preparing quote request…') : 'Send quote request';
  }

  function submitAgain(form, submitter) {
    form.setAttribute(snapshotReadyAttribute, 'true');
    form.setAttribute(nativeHandoffAttribute, 'true');

    if (typeof form.requestSubmit === 'function') {
      try {
        form.requestSubmit(submitter || undefined);
        if (!form.hasAttribute(snapshotReadyAttribute)) {
          setBusy(form, true, 'Sending quote request…');
          return true;
        }
        form.removeAttribute(snapshotReadyAttribute);
        form.removeAttribute(nativeHandoffAttribute);
        return false;
      } catch (error) {
        // Fall through to the native submit method for older browser implementations.
      }
    }

    if (submitter && typeof submitter.click === 'function') {
      submitter.click();
      if (!form.hasAttribute(snapshotReadyAttribute)) {
        setBusy(form, true, 'Sending quote request…');
        return true;
      }
      form.removeAttribute(snapshotReadyAttribute);
      form.removeAttribute(nativeHandoffAttribute);
      return false;
    }

    form.removeAttribute(snapshotReadyAttribute);
    if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
      form.removeAttribute(nativeHandoffAttribute);
      if (typeof form.reportValidity === 'function') form.reportValidity();
      return false;
    }
    setBusy(form, true, 'Sending quote request…');
    window.HTMLFormElement.prototype.submit.call(form);
    return true;
  }

  function formStillValid(form) {
    if (typeof form.checkValidity !== 'function' || form.checkValidity()) return true;
    if (typeof form.reportValidity === 'function') form.reportValidity();
    return false;
  }

  function handleSubmit(event) {
    var form = event.target.closest && event.target.closest(selector);
    if (!form) return;
    if (form.hasAttribute(snapshotReadyAttribute)) {
      form.removeAttribute(snapshotReadyAttribute);
      return;
    }
    if (form.hasAttribute(nativeHandoffAttribute)) {
      event.preventDefault();
      return;
    }
    if (activeRequestState && activeRequestState.form !== form) {
      event.preventDefault();
      setStatus(form, 'Another quote request is already being prepared. Wait for it to finish before sending again.', true);
      return;
    }
    var sharedCartMutation = window.RealleaderCartMutationCoordinator && window.RealleaderCartMutationCoordinator.state;
    if (sharedCartMutation) {
      event.preventDefault();
      setStatus(
        form,
        sharedCartMutation.status === 'unconfirmed'
          ? 'Reload and check the latest quote basket before sending. Nothing was sent.'
          : 'Finish the quote-basket update before sending your request. Nothing was sent.',
        true
      );
      return;
    }
    if (!window.fetch || !window.Promise) return;
    if (form.hasAttribute(preflightTokenAttribute)) {
      event.preventDefault();
      return;
    }

    event.preventDefault();
    var submitter = event.submitter || form.querySelector('[data-rl-quote-request-submit]');
    var preflightToken = String(++preflightSequence);
    var settledCurrentAttempt = false;
    var requestState = {
      form: form,
      status: 'preflight'
    };
    activeRequestState = requestState;
    form.setAttribute(preflightTokenAttribute, preflightToken);
    ensureReference(form);
    setBusy(form, true);
    setStatus(form, 'Refreshing the basket details before sending…');

    var preflight = fetchWithDeadline(cartJsonUrl(form), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }, preflightDeadlineMs, 'The quote basket check took too long.', function (response) {
      if (!response.ok) throw new Error('Unable to refresh the quote basket.');
      return response.json();
    })
      .then(function (cart) {
        if (window.RealleaderCartMutationCoordinator && window.RealleaderCartMutationCoordinator.state) {
          var cartMutationError = new Error('The quote basket changed while it was being checked.');
          cartMutationError.code = 'RL_CART_MUTATION_ACTIVE';
          throw cartMutationError;
        }
        if (!cart || !Array.isArray(cart.items) || cart.items.length < 1) {
          throw new Error('Your quote basket is empty. Add an item before sending a quote request.');
        }
        if (form.getAttribute(preflightTokenAttribute) !== preflightToken) {
          var cancelled = new Error('Quote basket check was cancelled.');
          cancelled.code = 'RL_PREFLIGHT_CANCELLED';
          throw cancelled;
        }
        updateSnapshot(form, cart);
        return cart;
      });

    withFinally(preflight, function () {
      if (form.getAttribute(preflightTokenAttribute) !== preflightToken) return;
      settledCurrentAttempt = true;
      form.removeAttribute(preflightTokenAttribute);
      setBusy(form, false);
    }).then(function () {
      if (!settledCurrentAttempt) return;
      if (!formStillValid(form)) {
        if (activeRequestState === requestState) activeRequestState = null;
        setStatus(form, 'Review the highlighted contact details, then send your quote request again. Nothing was sent.', true);
        return;
      }
      if (window.RealleaderCartMutationCoordinator && window.RealleaderCartMutationCoordinator.state) {
        if (activeRequestState === requestState) activeRequestState = null;
        setBusy(form, false);
        setStatus(form, 'The quote basket changed while it was being checked. Review the latest basket and send again. Nothing was sent.', true);
        return;
      }
      requestState.status = 'native-handoff';
      setStatus(form, 'Basket refreshed. Sending your quote request…');
      if (!submitAgain(form, submitter)) {
        if (activeRequestState === requestState) activeRequestState = null;
        setBusy(form, false);
        setStatus(form, 'The form could not be handed to Shopify. Review the highlighted details and try again. Nothing was sent.', true);
      }
    }, function (error) {
      if (!settledCurrentAttempt || error && error.code === 'RL_PREFLIGHT_CANCELLED') return;
      if (activeRequestState === requestState) activeRequestState = null;
      form.removeAttribute(snapshotReadyAttribute);
      var message;
      if (error && error.code === 'RL_CART_MUTATION_ACTIVE') {
        message = 'The quote basket changed while it was being checked. Review the latest basket and send again. Nothing was sent.';
      } else if (error && /basket is empty/i.test(error.message || '')) {
        message = error.message;
      } else if (error && error.code === 'RL_FETCH_TIMEOUT') {
        message = 'Checking the quote basket took too long. Your form details are still here. Please try again. Nothing was sent.';
      } else {
        message = 'We could not verify the latest quote basket. Your form details are still here. Please try again. Nothing was sent.';
      }
      setStatus(form, message, true);
    });
  }

  function referenceFromSuccess(success) {
    var reference = '';
    try {
      reference = new URLSearchParams(window.location.search || '').get('quote_reference') || '';
    } catch (error) {
      reference = '';
    }
    if (!reference) reference = success.getAttribute('data-rl-quote-success-reference') || '';
    return reference.replace(/[^A-Za-z0-9-]/g, '').slice(0, 80);
  }

  function showSuccessReference(reference) {
    if (!reference) return;
    document.querySelectorAll('[data-rl-quote-request-success]').forEach(function (success) {
      var row = success.querySelector('[data-rl-quote-success-reference-row]');
      var value = success.querySelector('[data-rl-quote-success-reference-value]');
      if (value) value.textContent = reference;
      if (row) row.hidden = false;
    });
  }

  function publishQuoteSuccess() {
    var success = document.querySelector('[data-rl-quote-request-success]');
    if (!success) return false;
    var reference = referenceFromSuccess(success);
    showSuccessReference(reference);
    clearPendingReferences();

    if (successPublishedThisPage) return true;
    if (!window.RealleaderAttribution || typeof window.RealleaderAttribution.publishEvent !== 'function') {
      return false;
    }

    var guardKey = successGuardPrefix + window.location.pathname + ':' + (reference || 'unreferenced');
    if (storageGet(guardKey) === '1') {
      successPublishedThisPage = true;
      return true;
    }

    var attribution = typeof window.RealleaderAttribution.getContactFields === 'function'
      ? window.RealleaderAttribution.getContactFields()
      : {};
    var itemCount = Number(success.getAttribute('data-rl-quote-success-item-count')) || 0;
    var published = window.RealleaderAttribution.publishEvent('realleader:lead_submitted', Object.assign({}, attribution, {
      enquiry_type: 'quote_request',
      product_range: 'quote_basket',
      quote_item_count: itemCount,
      page_location: window.location.origin + window.location.pathname
    }));

    if (published) {
      successPublishedThisPage = true;
      storageSet(guardKey, '1');
    }
    return published;
  }

  function initialiseForms() {
    document.querySelectorAll(selector).forEach(ensureReference);
    focusServerError();
    publishQuoteSuccess();
  }

  function resetTransientState() {
    activeRequestState = null;
    document.querySelectorAll(selector).forEach(function (form) {
      var status = form.querySelector('[data-rl-quote-request-status]');
      var statusText = status ? status.textContent || '' : '';
      form.removeAttribute(snapshotReadyAttribute);
      form.removeAttribute(preflightTokenAttribute);
      form.removeAttribute(nativeHandoffAttribute);
      setBusy(form, false);
      if (/Refreshing the basket|Basket refreshed\. Sending/i.test(statusText)) {
        setStatus(form, '');
      }
    });
  }

  function handlePageShow(event) {
    if (event && event.persisted === true) resetTransientState();
    publishQuoteSuccess();
  }

  function focusServerError() {
    var errors = Array.prototype.slice.call(document.querySelectorAll('.rl-quote-request__errors'));
    var visibleError = errors.find(function (error) {
      return !error.closest('[inert]') && error.getClientRects().length > 0;
    });
    if (visibleError) visibleError.focus();
  }

  document.addEventListener('submit', handleSubmit);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseForms);
  } else {
    initialiseForms();
  }
  document.addEventListener('visitorConsentCollected', publishQuoteSuccess);
  document.addEventListener('realleader:attribution-ready', publishQuoteSuccess);
  window.addEventListener('pageshow', handlePageShow);
  window.RealleaderQuoteRequest = {
    formatBasket: formatBasket,
    updateSnapshot: updateSnapshot,
    ensureReference: ensureReference,
    publishQuoteSuccess: publishQuoteSuccess
  };
})();
